import { api } from '@/api/client';
import { inquiryFormSchema, inquiryResponseSchema } from '@/lib/validation';
import type { InquiryResponse } from '@/types';

interface SubmitInquiryInput {
  studioId: number;
  content: string;
  imageFiles?: File[];
}

export function submitInquiry(input: SubmitInquiryInput): Promise<InquiryResponse> {
  const values = inquiryFormSchema.parse(input);
  const formData = new FormData();

  formData.append('studioId', String(values.studioId));
  formData.append('content', values.content);

  values.imageFiles?.forEach((file) => {
    formData.append('images[]', file);
  });

  return api('/inquiries', {
    method: 'POST',
    body: formData,
    responseSchema: inquiryResponseSchema,
  });
}
